import React from 'react';
import ButtonCTA from '@/components/ButtonCTA';
import ComparisonCard from './ComparisonCard';
import CheckListItem from './CheckListItem';
import ResponsiveHeading from './ResponsiveHeading';

interface ComparisonSectionProps {
  policeStationName?: string;
  policeStationLink?: string;
}

const ComparisonSection: React.FC<ComparisonSectionProps> = ({ 
  policeStationName,
  policeStationLink 
}) => (
  <section className="py-12 md:py-16 px-4 bg-gray-50">
    <div className="container mx-auto max-w-6xl">
      <ResponsiveHeading
        centered
        size="xl"
        subtext={`Compare our fast online service with traditional ${policeStationName ?`${policeStationName}` : 'police station'}  checks. Accepted in whole Ontario.`}
      >
        Online CRJMC vs. {policeStationName ? `${policeStationName} Check` : 'Police Station Check'}
      </ResponsiveHeading>
      <div className="grid md:grid-cols-2 gap-6 md:gap-8 mt-8 md:mt-12">
        <ComparisonCard 
          title="✓ Online CRJMC with Us" 
          bgClassName="bg-emerald-50" 
          titleClassName="text-emerald-700"
        >
          <ul className="space-y-3">
            <CheckListItem iconClassName="text-emerald-600">Results in <strong>15 minutes</strong></CheckListItem>
            <CheckListItem iconClassName="text-emerald-600">Apply <strong>24/7</strong> from anywhere</CheckListItem>
            <CheckListItem iconClassName="text-emerald-600"><strong>Digital format</strong> ready for license application</CheckListItem>
            <CheckListItem iconClassName="text-emerald-600"><strong>No appointment</strong> needed</CheckListItem>
            <CheckListItem iconClassName="text-emerald-600"><strong>Secure online</strong> verification</CheckListItem>
          </ul>
          <div className="mt-6 text-center">
            <ButtonCTA showSubheader={false} />
          </div>
        </ComparisonCard>
        
        <ComparisonCard title={`${policeStationName ? `${policeStationName}` : 'Police Station'} Process`} bgClassName="bg-gray-100">
          <ul className="space-y-3 text-gray-600">
            <CheckListItem iconClassName="text-gray-500"><strong>4+ weeks</strong> processing time</CheckListItem>
            <CheckListItem iconClassName="text-gray-500"><strong>Limited</strong> business hours</CheckListItem>
            <CheckListItem iconClassName="text-gray-500"><strong>Must visit</strong> in person</CheckListItem>
            <CheckListItem iconClassName="text-gray-500"><strong>Appointment required</strong></CheckListItem>
            <CheckListItem iconClassName="text-gray-500"><strong>Paper format</strong> needs scanning</CheckListItem>
          </ul>
          {policeStationName && policeStationLink && (
            <div className="mt-6 text-center">
              <a 
                href={policeStationLink}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-full inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-gray-700 bg-gray-100 border-2 border-gray-300 rounded-lg shadow-lg hover:shadow-xl hover:bg-gray-200 hover:border-gray-400 transition-all focus:outline-none focus:ring-4 focus:ring-gray-300 focus:ring-opacity-50"
              >
                Visit {policeStationName} Website
              </a>
            </div>
          )}
        </ComparisonCard>
      </div>
    </div>
  </section>
);

export default ComparisonSection; 